var EPSILON = 0.05; // Точность вычислений

/**
 * @description Функция для вычисления letterSpacing и wordSpacing
 */
export function calculateTextSpaces(containerEl, textEl) {
  var _containerEl$getBound = containerEl.getBoundingClientRect(),
    containerWidth = _containerEl$getBound.width;
  var middle = 0; // Начальное значение letterSpacing и wordSpacing
  var left = -20; // Минимальное значение letterSpacing и wordSpacing
  var right = 100; // Максимальное значение letterSpacing и wordSpacing

  // Счетчик итераций, нужен для ограничения количества проходов по циклу,
  // если не будет изменение ширины корректно считать ( на всякий случай )
  var count = 0;
  while (left <= right && count < 70) {
    middle = (left + right) / 2;
    textEl.style.letterSpacing = "".concat(middle, "px");
    textEl.style.wordSpacing = "".concat(middle, "px");
    if (
    // Ширина блока текста должна подсчитываться с учетом текущего letterSpacing, так как он будет довольно большим,
    // а для его вычисления используется scrollWidth, который не учитывает letterSpacing.
    // Поэтому мы вычитаем его из scrollWidth, чтобы получить реальную ширину текста
    textEl.scrollWidth - middle > containerWidth) {
      right = middle - EPSILON;
    } else {
      left = middle + EPSILON;
    }
    count++;
  }

  // Если после бинарного поиска ширина текста больше ширины контейнера из-за погрешности, то проводим дополнительный проход
  // по тексту, уменьшая letterSpacing и wordSpacing до тех пор, пока ширина текста не станет меньше ширины контейнера
  // или пока не достигнем максимального количества итераций
  while (textEl.scrollWidth - middle > containerWidth && count < 70) {
    // Если ширина текста больше ширины контейнера, уменьшаем letterSpacing и wordSpacing
    middle -= EPSILON;
    textEl.style.letterSpacing = "".concat(middle, "px");
    textEl.style.wordSpacing = "".concat(middle, "px");
  }
  return {
    letterSpacing: middle,
    wordSpacing: middle
  };
}